// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"_9e1425b4d3--checkbox-group--dt66l","divider":"_9e1425b4d3--divider--EAU6L"};